import { createActionNameBuilder } from '../create-action-name-builder';
import { ActionType } from '../enums';

/**
 * Хелпер для формирования имён комманд вида `command/general/init-app/trigger`
 */
export const commandNameBuilder = createActionNameBuilder(ActionType.COMMAND);
